module.exports = __webpack_public_path__ + "img/logot.39d4903f.svg";